import Vue from 'vue/dist/vue.esm'
import template from './role_filter_template.slim'

Vue.component('role-filter', {
  mixins: [template],
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    unselectedRoles() {
      return this.roles.filter((option) => !this.isSelected(option))
    },
    allRolesSelected() {
      return this.roles.length > 0 && this.unselectedRoles.length === 0
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    isSelected(option) {
      return this.value.includes(option.value)
    },
    toggleOption(option) {
      const remaining = this.value.filter((value) => value !== option.value)
      this.$emit('change', this.isSelected(option) ? remaining : [...remaining, option.value])
    },
    handleOutsideClick(event) {
      if (!this.isOpen) return
      if (event.composedPath().includes(this.$el)) return

      this.isOpen = false
    }
  }
})
